export enum DividerTypeOptions {
  LINE_AND_TEXT = 0, // Line with text in middle
  LINE_ONLY = 1, // Line only
  TEXT_ONLY = 2, // Text only
}

export const DIVIDER_DATA_HOOKS = {
  DIVIDER_DESIGN_PANEL: 'divider-design-panel',
  DIVIDER_TYPE_SELECTOR: 'divider-type-selector',
  DIVIDER_TYPES: {
    LINE_AND_TEXT: 'divider-type-line-and-text',
    LINE_ONLY: 'divider-type-line-only',
    TEXT_ONLY: 'divider-type-text-only',
  },
  TEXT_FONT_COLOR: 'divider-text-font-color',
  TEXT_ALIGNMENT: {
    LEFT: 'divider-text-alignment-left',
    CENTER: 'divider-text-alignment-center',
    RIGHT: 'divider-text-alignment-right',
  },
  LINE_OPACITY_COLOR: 'divider-line-opacity-color',
  LINE_WIDTH_SLIDER: 'divider-line-width-slider',
  RESET_BUTTON: 'divider-reset-button',
} as const;

export const DIVIDER_THUMBNAIL_SIZE = 72;
